import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'tab',
    'activeTabBar',
    'inactiveTabBar',
    'info',
    'scheduleInfo',
    'cargoInfo',
    'clearanceInfo',
    'transportInfo',
    'fileInfo',
  ];

  changeForm(event) {
    const { form } = event.params;
    this.activeTabBarTargets.forEach((bar) => bar.classList.add('hidden'));
    this.inactiveTabBarTargets.forEach((bar) => bar.classList.add('hidden'));
    const currentTabBar = this.activeTabBarTargets.find((tab) => event.currentTarget.contains(tab));
    currentTabBar.classList.remove('hidden');
    this.infoTargets.forEach((target) => target.classList.add('hidden'));
    this[`${form}InfoTarget`].classList.remove('hidden');
  }

  // eslint-disable-next-line class-methods-use-this
  clickFileInfoTab() {
    const fileTab = document.querySelector('.file-tab');

    if (fileTab) {
      fileTab.scrollIntoView();
      fileTab.click();
    }
  }
}
